import type { ComponentDefinition } from '../components/ui-element.type.js';
import type { UIElement } from '../components/index.js';
import type { GenericDecorator } from './decorator.type.js';

/*
 * Defines the component with tag and styles.
 */
export const Component = <T extends typeof UIElement>(
    config: ComponentDefinition
): GenericDecorator<T, ClassDecoratorContext> => {
    if (!config.tag) {
        throw new Error('tag property should exists in @Component decorator');
    }

    return (target: T, context: ClassDecoratorContext) => {
        if (context.kind === 'class') {
            return target.defineElement(config.tag, config.styles) as T;
        } else {
            throw new Error('@Component decorator is applied only to a class.');
        }
    };
};
